// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.js?" + {"vendors-node_modules_iframe-resizer_js_iframeResizer_contentWindow_js":"deb0155a906d24f54ad5","node_modules_babel-loader_lib_index_js_ruleSet_1_rules_0_use_0_node_modules_eslint-loader_dis-546ef7":"70271d232659c7e05b47"}[chunkId] + "";
};